import { render, staticRenderFns } from "./ProgramSection.vue?vue&type=template&id=c0ce889a&scoped=true&"
import script from "./ProgramSection.vue?vue&type=script&lang=ts&"
export * from "./ProgramSection.vue?vue&type=script&lang=ts&"
import style0 from "./ProgramSection.vue?vue&type=style&index=0&id=c0ce889a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0ce889a",
  null
  
)

export default component.exports